import { Store } from "@bryntum/schedulerpro";
import {ResourceType} from "../models/ResourceType.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

const onRemoveTypeFromEntity = (stores, records) => {
  // _type field is using typeId field to look up record from the store. In this listener, we
  // already have that record removed. Thus, we need to perform lookup by the id itself.
  records = records.map(r => r.id);

  stores.forEach((store) => {
    store.forEach((storeModel) => {
      if (records.includes(storeModel.typeId)) storeModel._type = null;
    }, null, {
      includeFilteredOutRecords: true,
      includeCollapsedGroupRecords: true
    });
  }, null, {
    includeFilteredOutRecords: true,
    includeCollapsedGroupRecords: true
  })
}

const onUpdateTypeOnEntity = (stores, record) => {
  stores.forEach((store) => {
    store.forEach((storeModel) => {
      if (storeModel.typeId === record.id) storeModel._type = record;
    }, null, {
      includeFilteredOutRecords: true,
      includeCollapsedGroupRecords: true
    });
  }, null, {
    includeFilteredOutRecords: true,
    includeCollapsedGroupRecords: true
  });
}

export class SwivuResourceTypeStore extends Store {

  static get configurable() {
    return {
      id: STORE_KEYS.resourceTypeStore,
      storeId: STORE_KEYS.resourceTypeStore,
      modelClass: ResourceType,
      useSparseIndex: true,
    }
  }

  onUpdate({ record, changes }) {
    const project = this.project || record.project;
    if (project) {
      const { resourceStore } = project;

      // Only update related records if something specific is changed, it will update cached `type` name
      if ('description' in changes || 'id' in changes) {
        onUpdateTypeOnEntity([resourceStore], record);
      }
    }
  }

  onRemove({ records }) {
    const project = this.project || records?.[0]?.project;
    if (project) {
      onRemoveTypeFromEntity([project.resourceStore], records);
    }
  }
}
